import { observer } from "mobx-react-lite";
import { Button, Header, Label, Segment } from "semantic-ui-react";
import { Formik, Form, Field, useFormik } from "formik";
import React, { useEffect, useState, useRef } from "react";
import MyTextInput, {
  MyTextInputConv,
  MyTextAreatConv,
} from "../../app/common/form/MyTextInput";
import Image from "react-bootstrap/Image";
import Modal from "react-bootstrap/Modal";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { IoLocationOutline } from "@react-icons/all-files/io5/IoLocationOutline";
import { VscMail } from "react-icons/vsc";
import { BsTelephone } from "react-icons/bs";
import logo from "../../images/INAP.png";
import iconfa from "../../images/icon-fa.svg";
import iconin from "../../images/icon-in.svg";
import iconyo from "../../images/icon-you.svg";
import icontw from "../../images/icon-tw.svg";
import "./ContactModalForm.css";



export default observer(function ContactModalForm(SOL: {
  show: any;
  onHide: any;
  cnombre: any;
  ccorreo: any;
}) {
  const apiURL = process.env.REACT_APP_API_URL + "/Notifications";

  const [mensj, setMensj] = useState("");
  const [telef, setTelef] = useState("");
  const [modalShow, setModalShow] = useState(true);
  const [bodyMsg, setBodyMsg] = useState("");
  const [isSending, setIsSending] = useState(false);
const [isSent, setIsSent] = useState(false);

  interface ContactValues {
    Subject: string;
    To: string;
  }

  const initialValues: ContactValues = {
    Subject: "Solicitud",
    To: "registro@inap.gob.gt",
  };
   

  const getSubmitHandler = (saving: any) => (values: any, formik: any) => {
    const endpoint = saving ? apiURL : apiURL;
    const formData = new FormData();
    const updatedValues = {
      ...values,
      Message: `<p>Nombre: ${SOL.cnombre}</p><p>Correo: ${SOL.ccorreo}</p><p>Teléfono: ${telef}</p><p>Mensaje:\n${mensj}`,
    };

    for (const key in updatedValues) {
      formData.append(key, updatedValues[key]);
    }

    return fetch(endpoint, {
      method: "POST",
      body: formData,
    }).then(async function (r) {
      if (r.status === 200) {
        setModalShow(false);

               
        // Crea un nuevo FormData para el correo de confirmación
        const confirmationEmailFormData = new FormData();
        // Agrega los valores específicos para el correo de confirmación
        confirmationEmailFormData.append('Subject', 'Confirmación de Solicitud');
        confirmationEmailFormData.append('To', `${SOL.ccorreo}`); // Reemplaza con el nuevo correo
        confirmationEmailFormData.append('Message', 'Tu solicitud ha sido recibida, pronto te contactaremos.'); // Reemplaza con el nuevo correo
  
        // Envía el nuevo FormData al endpoint de correo de confirmación
        const confirmationEmailEndpoint = endpoint;
  
        const confirmationEmailResponse = await fetch(confirmationEmailEndpoint, {
          method: "POST",
          body: confirmationEmailFormData,
        });
  
        if (confirmationEmailResponse.status === 200) {
          console.log("Correo de confirmación enviado con éxito.");
        } else {
          console.log("Error al enviar el correo de confirmación.");
        }



        return console.log(formData);
      } else {
        console.log("error");
      }
    });
  };

  return (
    <>
      <Modal
        {...SOL}
        centered
        size="lg"
        className="modal-faqs modal-contact"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton className="close-fix">
          {" "}
        </Modal.Header>

        <Modal.Body>
          <Col sm={12} md={6} className="ContMod-left">
            <Row className="footer-body">
              <Col className="footer-b1">
                <Image src={logo}></Image>
              </Col>
              <Col className="footer-b2">
                <p className="icon-location">
                  {" "}
                  <IoLocationOutline /> Boulevard los Próceres 16-40 Zona 10,
                  <br></br>Ciudad de Guatemala,<br></br>Guatemala,
                  Centroamérica.
                </p>
                <p className="icon-phone">
                  {" "}
                  <BsTelephone />
                  Teléfono: 2419-8181
                </p>
                <p className="icon-mail">
                  {" "}
                  <VscMail />
                  Correo: información@inap.gob.gt.
                </p>
              </Col>
              <Col className="footer-b3">
                <p>Síguenos en nuestras redes</p>
                <div className="footer-socials">
                  <Image src={iconfa} />
                  <Image src={iconin} />
                  <Image src={iconyo} />
                  <Image src={icontw} />
                </div>
              </Col>
            </Row>
          </Col>

          <Col sm={12} md={6} className="ContMod-right">
            <Formik
              // validationSchema={validationSchema}
              initialValues={initialValues}
              onSubmit={(values, { setSubmitting }) => {
                getSubmitHandler(values);
                setSubmitting(false);
              }}
            >
              {(formik) => (
                <>
                  <Form>
                    <MyTextInputConv
                      label="Nombre"
                      placeholder=""
                      type="input"
                      id="nombre"
                      name="nombre"
                      value={SOL.cnombre}
                      readOnly={"readOnly"}
                    />

                    <MyTextInputConv
                      label="Correo"
                      placeholder=""
                      type="input"
                      id="correo"
                      name="correo"
                      value="registro@inap.gob.gt"
                      readOnly={"readOnly"}
                      />

                    <MyTextInputConv
                      label="Teléfono"
                      placeholder=""
                      type="input"
                      id="telefono"
                      name="telefono"
                      onChange={(e: any) => {
                        const newTelef = e.target.value;
                        setTelef(newTelef);
                        const newBodyMsg = `Nombre: ${SOL.cnombre}\nCorreo: ${SOL.ccorreo}\nTeléfono: ${newTelef}\n\nMensaje:\n${mensj}`;
                        setBodyMsg(newBodyMsg);
                      }}
                    />

                    <MyTextAreatConv
                      label="Escribe tu solicitud"
                      placeholder=""
                      type="input"
                      id="Message"
                      name="Message"
                      onChange={(e: any) => {
                        const newMensj = e.target.value;
                        setMensj(newMensj);
                        const newBodyMsg = `Nombre: ${SOL.cnombre}\nCorreo: ${SOL.ccorreo}\nTeléfono: ${telef}\n\nMensaje:\n${newMensj}`;
                        setBodyMsg(newBodyMsg);
                      }}
                    />

<Button
  variant="primary"
  disabled={isSending || isSent}
  onClick={() => {
    if (formik.isValid) {
      setIsSending(true);
     
      getSubmitHandler(true)(formik.values, formik).then(() => {
        setIsSent(true);
       
        setTimeout(() => {
          setIsSending(false);
          setIsSent(false);
        
          SOL.onHide(); 
        }, 3800); 
      });
    } else {
      
    }
  }}
>
  {isSending ? "Enviando..." : isSent ? "Enviado" : "Enviar Solicitud"}
</Button>
                  </Form>
                </>
              )}
            </Formik>
          </Col>
        </Modal.Body>
      </Modal>
    </>
  );
});
